import { render, staticRenderFns } from "./VideoLibraryPage.vue?vue&type=template&id=1fa7f119&scoped=true&"
import script from "./VideoLibraryPage.vue?vue&type=script&lang=js&"
export * from "./VideoLibraryPage.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibraryPage.vue?vue&type=style&index=0&id=1fa7f119&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7f119",
  null
  
)

export default component.exports